export enum StopStatus {
    Started = "Started",
    Complete = "Complete",
    Pending = "Pending"
}